module.exports = __webpack_public_path__ + "static/media/tiktok.04fc00b7.svg";